export default {
  'app.setting.pagestyle': 'Услуби саҳифа',
  'app.setting.themecolor': 'Ранги мавзуъ',
  'app.setting.navigationmode': 'Режими паймоиш',
};


